import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Card, Form, Button, Alert, Container, Spinner, Badge } from 'react-bootstrap';
import { FaLock, FaCheckCircle, FaKey } from 'react-icons/fa';

const ResetPassword = ({ token, setCurrentView }) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    // Xử lý token để loại bỏ các ký tự thừa
    const cleanToken = token ? String(token).replace(/\/$/, "").trim() : null;

    useEffect(() => {
        if (!cleanToken) {
            setError("Mã xác thực không hợp lệ. Vui lòng kiểm tra lại đường dẫn.");
        }
    }, [cleanToken]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        
        if (password.length < 6) {
            return setError('Mật khẩu phải có ít nhất 6 ký tự!');
        }

        if (password !== confirmPassword) {
            return setError('Mật khẩu xác nhận không khớp!');
        }

        setLoading(true);

        try {
            
            const res = await api.post('/api/auth/reset-password', { 
                token: cleanToken, 
                password: password 
            });

            if (res.data.success) {
                setMessage("Mật khẩu của bạn đã được cập nhật thành công!");
                setTimeout(() => setCurrentView('login'), 3000);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Link khôi phục đã hết hạn hoặc không hợp lệ.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
            <Card className="shadow-lg border-0 animate__animated animate__fadeIn" style={{ maxWidth: '420px', width: '100%', borderRadius: '15px', overflow: 'hidden' }}>
                
                <div className="text-center p-4" style={{ background: 'linear-gradient(135deg, #111827 0%, #374151 100%)', borderBottom: '4px solid #28a745' }}>
                    <Badge bg="success" text="white" className="mb-2 px-3 fw-bold text-uppercase">Cập nhật bảo mật</Badge>
                    <h3 className="text-white fw-black mb-0 text-uppercase" style={{ letterSpacing: '1px' }}>Mật khẩu mới</h3>
                </div>

                <Card.Body className="p-4 bg-white text-dark">
                    {message ? (
                        <div className="text-center py-3">
                            <FaCheckCircle size={50} className="text-success mb-3 animate__animated animate__zoomIn" />
                            <Alert variant="success" className="fw-bold border-0 shadow-sm">{message}</Alert>
                            <p className="text-muted small italic">Đang chuyển hướng về trang Đăng nhập...</p>
                            <Button variant="dark" className="w-100 mt-2 fw-bold" onClick={() => setCurrentView('login')}>ĐĂNG NHẬP NGAY</Button>
                        </div>
                    ) : (
                        <>
                            {error && <Alert variant="danger" className="small fw-bold border-0 shadow-sm text-center py-3">{error}</Alert>}
                            
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold small text-muted text-uppercase">
                                        <FaKey className="me-1"/> Mật khẩu mới
                                    </Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        value={password} 
                                        onChange={(e) => setPassword(e.target.value)} 
                                        required 
                                        placeholder="Tối thiểu 6 ký tự"
                                        disabled={loading || !cleanToken}
                                        className="shadow-sm"
                                        style={{ height: '50px', border: '2px solid #eee', borderRadius: '8px' }} 
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label className="fw-bold small text-muted text-uppercase">
                                        <FaLock className="me-1"/> Xác nhận mật khẩu
                                    </Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        value={confirmPassword} 
                                        onChange={(e) => setConfirmPassword(e.target.value)} 
                                        required 
                                        placeholder="Nhập lại mật khẩu mới"
                                        disabled={loading || !cleanToken}
                                        className="shadow-sm"
                                        style={{ height: '50px', border: '2px solid #eee', borderRadius: '8px' }} 
                                    />
                                </Form.Group>

                                <Button 
                                    variant="success" 
                                    type="submit" 
                                    className="w-100 py-3 fw-black text-white shadow border-0" 
                                    disabled={loading || !cleanToken}
                                    style={{ borderRadius: '10px', background: '#28a745' }}
                                >
                                    {loading ? (
                                        <><Spinner size="sm" animation="border" className="me-2" /> ĐANG XỬ LÝ...</>
                                    ) : (
                                        "XÁC NHẬN ĐỔI MẬT KHẨU"
                                    )}
                                </Button>
                            </Form>
                        </>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ResetPassword;